// removed by extract-text-webpack-plugin
module.exports = {"loading":"_3f6XcXvrtLUEW_vxM5BGJL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/Components/Loading.css
 ** module id = 1712
 ** module chunks = 1
 **/